import React from 'react'
import Points from '../models/Points'
import { useParams } from 'react-router-dom'

function useUserPoints () {
  const { id } = useParams()
  const [points, setPoints] = React.useState({
    points: [],
    totals: {}
  })

  function getPoints() {
    Points.getHistory(id)
      .then(res => setPoints(res))
  }

  React.useEffect(() => {
    getPoints()
  }, [id])

  async function addPoints(points, concept) {
    await Points.addPoints(id, points, concept)
    getPoints()
  }

  return {
    points,
    addPoints
  }
}

export default useUserPoints